var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme4-wrapper"},[_c('theme4-the-header'),_c('router-view'),_c('theme4-the-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }